<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ page.nome }}</h4>
    <button type="button" (click)="bsModalRef.hide();" class="close pull-right button" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="container">

      <form [formGroup]="formUsuario">

        <div class="row justify-content-center text-center" *ngIf="page.tipo === 'alterar'">
          <div class="form-group col-md-6">
            <label class="col-form-label text-center" for="id">Código*</label>
            <input type="number" class="form-control input-center" formControlName="id" id="id"
                    [value]="usuario.id" hidden>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label class="col-form-label" for="nome">Nome*</label>
            <input type="text" class="form-control" formControlName="nome" id="nome">
            <div *ngIf="verifyValid('nome')" class="alert alert-warning">
              <div [hidden]="!verifyReq('nome')">
                Campo obrigatório.
              </div>
            </div>
          </div>
          <div class="form-group col-md-3">
            <label class="col-form-label" for="sexo">Sexo</label>
            <select class="form-control" formControlName="sexo" id="sexo">
              <option value="M">Masculino</option>
              <option value="F">Feminino</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label class="col-form-label" for="data_nasc">Data Nascimento</label>
            <input type="text" class="form-control"
                    bsDatepicker
                    formControlName="data_nasc"
                    [bsConfig]="bsConfig">
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label class="col-form-label" for="cpf">CPF</label>
            <input type="text" class="form-control" formControlName="cpf" id="cpf" #cpf
                    (focus)="loaders.errorCPF = false;" (blur)="trataCPF(cpf);">
            <div [hidden]="!loaders.errorCPF" class="alert alert-warning">
              CPF incorreto!
            </div>
          </div>
          <div class="form-group col-md-6">
            <label class="col-form-label" for="departamento">Departamento</label>
            <input type="text" class="form-control" formControlName="departamento" id="departamento">
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-3">
            <label class="col-form-label" for="associado">
              Associado{{ (page.tipo === 'novo') ? '*' : ''}}
            </label>
            <input type="text" class="form-control"
            formControlName="associado" id="associado" #assoc [readonly]="page.tipo === 'alterar'"
            (blur)="verifyAssoc(assoc.value)">
            <div *ngIf="verifyValid('associado')" class="alert alert-warning">
              <div [hidden]="!verifyReq('associado')">
                Campo obrigatório.
              </div>
            </div>
            <div [hidden]="!loaders.errorASS" class="alert alert-warning">
              Não cadastrado.
            </div>
          </div>
          <div class="form-group col-md-3">
            <label class="col-form-label" for="est_impacto">Estudo de Impacto*</label>
            <select class="form-control" formControlName="est_impacto" id="est_impacto">
              <option value="S">Sim</option>
              <option value="N">Não</option>
            </select>
            <div *ngIf="verifyValid('est_impacto')" class="alert alert-warning">
              <div [hidden]="!verifyReq('est_impacto')">
                Campo obrigatório.
              </div>
            </div>
          </div>
          <div class="form-group col-md-3">
            <label class="col-form-label" for="tipo">Tipo</label>
            <select class="form-control" formControlName="tipo" id="tipo">
              <option value="A">Associado</option>
              <option value="B">Matriz</option>
              <option value="G">Gestor</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label class="col-form-label" for="status">Status</label>
            <select class="form-control" formControlName="status" id="st_cad">
              <option value="A">Ativo</option>
              <option value="I">Inativo</option>
              <option value="B">Bloqueado</option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4">
            <label class="col-form-label" for="cep">CEP</label>
            <input type="text" class="form-control" formControlName="cep" id="cep" #cep
                    (focus)="loaders.errorCEP = false;" (blur)="buscaCep(cep)">
            <div [hidden]="!loaders.errorCEP" class="alert alert-warning">
              CEP incorreto!
            </div>
          </div>
          <div class="form-group col-md-4">
            <label class="col-form-label" for="municipio">Cidade</label>
            <div class="input-group">
              <input type="text" class="form-control" formControlName="nome_cid" id="municipio">
              <input type="text" class="form-control" formControlName="municipio" hidden>
              <span class="input-group-btn">
                  <button class="btn btn-secondary button" (click)="mostraCidades()" type="button">
                    <i class="fa fa-search"></i>
                  </button>
                </span>
            </div>
          </div>
          <div class="form-group col-md-4">
            <label class="col-form-label" for="bairro">Bairro</label>
            <input type="text" class="form-control" formControlName="bairro" id="bairro">
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label class="col-form-label" for="endereco">Endereço</label>
            <input type="text" class="form-control" formControlName="endereco" id="endereco">
          </div>
          <div class="form-group col-md-2">
            <label class="col-form-label" for="nro_ender">Número</label>
            <input type="text" class="form-control" formControlName="nro_ender" id="nro_ender">
          </div>
          <div class="form-group col-md-4">
            <label class="col-form-label" for="cpl_ender">Complemento</label>
            <input type="text" class="form-control" formControlName="cpl_ender" id="cpl_ender">
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label class="col-form-label" for="telefone">Telefone</label>
            <input type="text" class="form-control" formControlName="telefone" id="telefone"
                   (blur)="trataFone(tel, 'telefone')" #tel>
            <div [hidden]="!loaders.errorTEL" class="alert alert-warning">
              Formato incorreto.
            </div>
          </div>
          <div class="form-group col-md-6">
            <label class="col-form-label" for="celular">Celular</label>
            <input type="text" class="form-control" formControlName="celular" id="celular"
                   (blur)="trataFone(cel, 'celular')" #cel>
            <div [hidden]="!loaders.errorCEL" class="alert alert-warning">
              Formato incorreto.
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label class="col-form-label" for="email">
              Email*
            </label>
            <input type="text" class="form-control" formControlName="email" id="email">
            <div *ngIf="verifyValid('email')" class="alert alert-warning">
              <div [hidden]="!verifyReq('email')">
                Campo obrigatório.
              </div>
            </div>
          </div>
          <div class="form-group col-md-6">
            <label class="col-form-label" for="usuario">
              Usuário*
            </label>
            <input type="text" class="form-control" formControlName="usuario" id="usuario">
            <div *ngIf="verifyValid('usuario')" class="alert alert-warning">
              <div [hidden]="!verifyReq('usuario')">
                Campo obrigatório.
              </div>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="(page.pagPai === 'usuarios' && admin) ; else altPass">
          <div class="form-group col-md-6">
            <label class="col-form-label" for="senha">
              Senha{{ (page.tipo === 'novo') ? '*' : ''}}
            </label>
            <input type="password" class="form-control"
                    id="senha" #senha formControlName="senha"
                    (blur)="verifySenha(senha.value, rep_senha.value)">
            <div *ngIf="verifyValid('senha')" class="alert alert-warning">
              <div [hidden]="!verifyReq('senha')">
                Campo obrigatório.
              </div>
            </div>
            <div [hidden]="!loaders.errorPAS" class="alert alert-warning">
              As senhas não conferem.
            </div>
          </div>
          <div class="form-group col-md-6">
            <label class="col-form-label" for="rep_senha">
              Repita a senha{{ (page.tipo === 'novo') ? '*' : ''}}
            </label>
            <input type="password" class="form-control"
                    id="rep_senha" #rep_senha formControlName="rep_senha"
                    (blur)="verifySenha(senha.value, rep_senha.value)">
            <div *ngIf="verifyValid('rep_senha')" class="alert alert-warning">
              <div [hidden]="!verifyReq('rep_senha')">
                Campo obrigatório.
              </div>
            </div>
            <div [hidden]="!loaders.errorPAS" class="alert alert-warning">
              As senhas não conferem.
            </div>
          </div>
        </div>

        <ng-template #altPass>
          <div class="row">
            <div class="form-group col-md-4">
              <label class="col-form-label" for="senha_atual">Senha atual*</label>
              <input type="password" class="form-control"
                      id="senha_atual" #senha_atual formControlName="senha_atual"
                      (blur)="verifySenhaAt(senha_atual.value)">
              <div *ngIf="(senha_atual.value)">
                <div [hidden]="!loaders.errorPAA" class="alert alert-warning">
                  Senha incorreta.
                </div>
              </div>
              <div *ngIf="verifyValid('senha_atual')" class="alert alert-warning">
                <div [hidden]="!verifyReq('senha_atual')">
                  Campo obrigatório.
                </div>
              </div>
            </div>
            <div class="form-group col-md-4">
              <label class="col-form-label" for="senha_nova">Nova senha</label>
              <input type="password" class="form-control"
                      id="senha_nova" #senha_nova formControlName="senha_nova"
                      (keypress)="!loaders.errorPAA" (blur)="verifySenha(senha_nova.value, rep_senha_nova.value)">
              <div [hidden]="!loaders.errorPAS" class="alert alert-warning">
                As senhas não conferem.
              </div>
            </div>
            <div class="form-group col-md-4">
              <label class="col-form-label" for="rep_senha_nova">Repita a senha</label>
              <input type="password" class="form-control"
                      id="rep_senha_nova" #rep_senha_nova formControlName="rep_senha_nova"
                      (keypress)="!loaders.errorPAA" (blur)="verifySenha(senha_nova.value, rep_senha_nova.value)">
              <div [hidden]="!loaders.errorPAS" class="alert alert-warning">
                As senhas não conferem.
              </div>
            </div>
          </div>
        </ng-template>

        <div *ngIf="admin">
          <div class="row justify-content-center text-center" *ngIf="page.tipo === 'alterar'">
            <div class="form-group col-md-6">
              <label class="col-form-label text-center" for="status">Status</label>
              <select class="form-control input-center" formControlName="status" id="status">
                <option value="A">Ativo</option>
                <option value="I">Inativo</option>
                <option value="B">Bloqueado</option>
              </select>
            </div>
          </div>
        </div>
        <br/>
        <div *ngIf="page.tipo ==='alterar' && admin">
          Usuário cadastrado na data: <strong>{{ usuario.data_inc | date:'dd/MM/yyyy' }}</strong>.
        </div>
        <br/>

        <div class="modal-footer">
          <button class="btn btn-secondary button" data-dismiss="modal"
                  (click)="bsModalRef.hide();">Fechar
          </button>
          <button (click)="setUsuario()" class="btn btn-primary button"
                  [disabled]="!formUsuario.valid || loaders.errorPAS || loaders.errorPAA
                              || loaders.errorTEL || loaders.errorCEL || loaders.errorCEP
                              || loaders.errorCPF || loaders.errorASS">
            {{ page.botao }}
          </button>
        </div>
      </form>
    </div>
  </div>
  <ngx-loading [show]="loaders.loading"></ngx-loading>
</div>

<app-cidades *ngIf="loaders.loadCidades" (selectCidade)="onSelectCidade($event)" #buscaCidades></app-cidades>